import React, { useState } from "react";
import { FormFieldSet } from "../../../../../components";
import { PropsTable, TEXTAREALIST_PROPS } from "./Props/Props";

const CATEGORIES = {
  core: { label: "Core", color: "#EFF6FF", textColor: "#1D4ED8" },
  display: { label: "Display", color: "#F0FDF4", textColor: "#15803D" },
  behavior: { label: "Behavior", color: "#FFFBEB", textColor: "#B45309" },
};


const TextAreaList = () => {
  const [name, setName] = useState("");
  const [nameFilled, setNameFilled] = useState("Describe Here");
  const [nameDisabled, setNameDisabled] = useState("");
  const [nameFilledDisabled, setNameFilledDisabled] = useState("Describe Here");

  return (
    <div>
      <div className="grid grid-cols-4 gap-5 my-5 mb-30">
        <div>
          <FormFieldSet
            title="Discription"
            type="textArea"
            placeholder="Enter Discription"
            value={name}
            onChange={(e) => setName(e)}
          />
        </div>
        <div>
          <FormFieldSet
            title="Discription"
            type="textArea"
            placeholder="Enter Discription"
            value={nameFilled}
            onChange={(e) => setNameFilled(e)}
            shadow={true}
          />
        </div>
        <div>
          <FormFieldSet
            title="Discription"
            type="textArea"
            placeholder="Enter Discription"
            value={nameDisabled}
            onChange={(e) => setNameDisabled(e)}
            disabled={true}
            shadow={true}
          />
        </div>
        <div>
          <FormFieldSet
            title="Discription"
            type="textArea"
            placeholder="Enter Discription"
            value={nameFilledDisabled}
            onChange={(e) => setNameFilledDisabled(e)}
            disabled={true}
          />
        </div>
      </div>

      <PropsTable
        data={TEXTAREALIST_PROPS}
        title="textArea — Props Reference"
        typeLabel='type="textArea"'
        categories={CATEGORIES}
      />
    </div>
  );
};

export default TextAreaList;
